export interface Staff {
  name: string;
  gender: string;
  phone: string;
  active: boolean;
  email: string;
  aadhaarNumber: string;
  role: string;
}

export const StaffType = {
  LIBRARIAN: "LIBRARIAN",
  SECURITY: "SECURITY",
  JANITOR: "JANITOR",
} as const;

export type StaffType = (typeof StaffType)[keyof typeof StaffType];

export const StaffTypeLabel: Record<StaffType, string> = {
  LIBRARIAN: "Librarian",
  SECURITY: "Security",
  JANITOR: "Janitor",
};
